import FupOrganisationListPagingResultModelBase from '../_generated/modelBases/fup-organisation-list-paging-result-model-base';

export default class FupOrganisationListPagingResultModel extends FupOrganisationListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
